import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {
  @Input() selected: boolean;
  @Output() selectionSwitch = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  onSelection() {
    const revertedSelect = !this.selected;
    this.selectionSwitch.emit(revertedSelect);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/checkbox/checkbox.component.ts